/**
 * Shared React Query `meta.invalidates` tag sets for mutations.
 * Pair with matching `meta.tags` on queries so the shared MutationCache can refetch.
 */

export const DEFAULT_ARCHIVE_INVALIDATES = [
  'getProperties',
  'getMultiplexUnits',
  'getPropertyTableUnitsList',
  'zramOptions',
] as const;
